module.exports = __webpack_public_path__ + "assets/img/money.954fffc7.svg";